__turbopack_context__.v({
  "nav": "Navigation-module-scss-module__aZuhFW__nav",
  "navList": "Navigation-module-scss-module__aZuhFW__navList",
  "root": "Navigation-module-scss-module__aZuhFW__root",
});
